import React, { Component, PureComponent } from 'react';
import sha256 from 'js-sha256';
import * as yup from 'yup'
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';

import TextFields from '../UI/TextField-f';
import SelectMenu from '../UI/Select-f';
import RadioGroup from '../UI/Radio-f';
import CheckboxElement from '../UI/Checkbox-f'
import SwitchToggle from '../UI/SwitchToggle-f';
import ImageUpload from '../UI/ImageUpload-f';
import InputTabs from '../UI/InputTabs-f';
import { convertByTimeZone } from '../../utils/utils';



import {CUSTOMER_TYPES, HOURS, DAYS, CAR_TYPES, WEEKDAYS_MAP, WEEKDAYS, links} from '../../utils/constants';

import { getCuisines, getFoodCategories, getZones, addCustomer, editCustomer } from '../../store/actions';

import BranchLocation from './BranchLocation';

const getWeekdays = openingHours => {
    let weekdays = {};
    for (const hour of openingHours) {
        weekdays[WEEKDAYS_MAP[hour.weekday]] = true;
    }
    return weekdays;
};

const shapeCuisines = (values, cuisines) => {
    let cuisinesData = {};
    for (const value of values) {
        const index = cuisines.findIndex(cuisine => value === cuisine.id);
        cuisinesData[ `${cuisines[index]['id']}_` ] = true;
    }
    return cuisinesData;
};

const shapeFoodCategores = (values, foodCategores) => {
    let foodCategoriesData = {};
    for (const value of values) {
        const index = foodCategores.findIndex(foodCategory => value === foodCategory.id);
        foodCategoriesData[ `${foodCategores[index]['id']}_` ] = true;
    }
    return foodCategoriesData;

};

const validateIsOnlyNumbersAndDot = value => {
    const regex = /^[0-9.]+$/g;
    if(!value || regex.test(value) ) {
        return true;
    }

    return false;
};

const isOnlyNumbersSpacesAndLetters = value => {
    const regex = /^[a-zA-Z\u0600-\u06FF0-9 ]*$/;
    if(!value || regex.test(value) ) {
        return true;
    }

    return false;
};

const validateIsOnlyNumbersAndDotAndplus = value => {
    const regex = /^[0-9+ ]*$/;
    if(!value || regex.test(value) ) {
        return true;
    }

    return false;
};


const validateImage = value => {
    if(value.indexOf('jpeg') === -1 && value.indexOf('jpg') === -1 && value.indexOf('png') === -1) {
        return false;
    }
    return true;
};

const validateBranches = (value, prop) => {
    const keys = Object.keys(value);
    if (keys.length === 0) return false;
    let val = true;
    for (const key in value) {
        if (!value[key].zone || !value[key].address) {
            val = false;
            break;
        }
    }
    return val;
};

const textErrorMessage = 'Valid characters include A-z, 0-9.';
const mandatoryErrorMessage = 'This field is mandatory.';
const numbersErrorMessage = 'Valid characters include 0-9.';
const imageErrorMessage = 'Valid formats are JPG and PNG.';

class Customer extends Component {

    state = {
        locations: [{ name: 'Location 1', isMapShown: true, is_active: false }],
        error: ''
    };

    componentDidMount() {
        this.props.getFoodCategories();
        this.props.getCuisines();
        this.props.getZones();

        if (this.props.customer) {
            this.setLocations();
        }
    }

    setLocations = () => {
        const locations = [];
        const { branches } = this.props.customer.restaurant;
        for (let i = 0; i < branches.length; i++) {
            locations.push({ name: `Location ${i + 1}`, isMapShown: true, ...branches[i] });
        }
        this.setState({ locations });
    };

    addLocation = (event, index) => {
        event.stopPropagation();
        this.setState(prevState => {
            const changedLocations = prevState.locations.map(location => {
                return {...location, isMapShown: false };
            });
            const newLocation = { name: `Location ${prevState.locations.length + 1}`, isMapShown: true };
            const newLocations =  [...changedLocations, newLocation];
            return { locations: newLocations};
        });

    };

    removeLocation = (event, index, setFieldValue, values) => {
        event.stopPropagation();
        const locations = [...this.state.locations];
        locations.splice(index, 1);
        if(locations.length === 1) {
            locations[0].isMapShown = true;
        }
        const newLocations = locations.map((location, i) => ({...location, name: `Location ${i + 1}`}));
        this.setState({ locations: newLocations });

        if (values.hasOwnProperty('branches') && values.branches[index]) {
            const newValue = [...values.branches];
            newValue.splice(index, 1);
            setFieldValue('branches', newValue);
        }
    };

    changeMapState = (event, locationName) => {
        const locations = [...this.state.locations];
        const newLocations = locations.map(location => {
            if (locationName === location.name) {
                event.stopPropagation();
                return {...location, isMapShown: !location.isMapShown }
            }
            if (locationName === 'all') {
                return {...location, isMapShown: false }
            }
            return {...location, isMapShown: false };
        });
        this.setState({locations: newLocations});
    };

    
    render() {
        const { props } = this;
        let openHoursFrom = '';
        let openHoursTo = '';
        let exclusive_ribbon = '';
        if(props.customer) {
            openHoursFrom = convertByTimeZone(props.customer.restaurant.opening_hours[0] && props.customer.restaurant.opening_hours[0].from_hour.substr(0,5),true);
            openHoursTo = convertByTimeZone(props.customer.restaurant.opening_hours[0] && props.customer.restaurant.opening_hours[0].to_hour.substr(0,5),true);
            exclusive_ribbon = props.customer.restaurant.exclusive_ribbon ? 'yes' : 'no';
        }
        const cuisines_data = props.customer && props.cuisines && shapeCuisines(props.customer.restaurant.cuisines, props.cuisines) || {};
        if(Object.keys(cuisines_data).length === 0 && props.customer) {
            return null;
        }
        return (
            <Formik
                validationSchema={yup.object().shape({
                    username: yup.string().required(mandatoryErrorMessage),
                    password: yup.string().min(6, 'The number of characters should be at least 6.').required(mandatoryErrorMessage),
                    password_edit: yup.string().min(6, 'The number of characters should be at least 6.'),
                    customerName_en: yup.string().required(mandatoryErrorMessage).test('name', textErrorMessage, isOnlyNumbersSpacesAndLetters),
                    customerName_ar: yup.string().required(mandatoryErrorMessage).test('name', textErrorMessage, isOnlyNumbersSpacesAndLetters),
                    customerPhone: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDotAndplus),
                    description_en: yup.string().required(mandatoryErrorMessage).test('name', textErrorMessage, isOnlyNumbersSpacesAndLetters),
                    description_ar: yup.string().required(mandatoryErrorMessage).test('name', textErrorMessage, isOnlyNumbersSpacesAndLetters),
                    image: yup.string().required(mandatoryErrorMessage).test('name', imageErrorMessage, validateImage),
                    from: yup.string().required(mandatoryErrorMessage),
                    to: yup.string().required(mandatoryErrorMessage),
                    agreed_delivery_fee: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    user_delivery_fee: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    delivery_time: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    agreed_percent_sale: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    agreed_radius: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    minimum_order: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    maximum_order: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    driver_fee: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDot),
                    relationship_manager_phone_number: yup.string().required(mandatoryErrorMessage).test('name', numbersErrorMessage, validateIsOnlyNumbersAndDotAndplus),
                    relation_manager_name_en: yup.string().required(mandatoryErrorMessage).test('name', textErrorMessage, isOnlyNumbersSpacesAndLetters),
                    relation_manager_name_ar: yup.string().required(mandatoryErrorMessage).test('name', textErrorMessage, isOnlyNumbersSpacesAndLetters),
                    exclusive_ribbon: yup.string().required(mandatoryErrorMessage),
                    car_type: yup.string().required(mandatoryErrorMessage),
                    cuisines_data: yup.string().required(mandatoryErrorMessage),
                    food_categories_data: yup.string().required(mandatoryErrorMessage),
                    branches: yup.mixed().test('name', '${value}', validateBranches),
                })}
                initialValues={{
                    type: (props.customer && props.customer.type) || 'tam',
                    username: (props.customer && props.customer.username) || '',
                    password: (props.customer && 'password') || '',
                    password_edit: '',
                    customerName_en: (props.customer && props.customer.restaurant.name) || '',
                    customerName_ar: (props.customer && props.customer.restaurant.name_ar) || '',
                    customerPhone: (props.customer && props.customer.restaurant.phone_number) || '+9665',
                    description_en: (props.customer && props.customer.restaurant.description) || '',
                    description_ar: (props.customer && props.customer.restaurant.description_ar) || '',
                    image: (props.customer && props.customer.restaurant.image) || [],
                    from: openHoursFrom,
                    to: openHoursTo,
                    weekdays: (props.customer && getWeekdays(props.customer.restaurant.opening_hours)) || {},
                    agreed_radius: (props.customer && props.customer.restaurant.agreed_radius) || '',
                    agreed_delivery_fee: (props.customer && props.customer.restaurant.delivery_fee) || '',
                    user_delivery_fee: (props.customer && props.customer.restaurant.user_share_delivery_fee) || '',
                    delivery_time: (props.customer && props.customer.restaurant.delivery_time) || '',
                    agreed_percent_sale:  (props.customer && props.customer.restaurant.percentage_sales) || '',
                    minimum_order: (props.customer && props.customer.restaurant.minimum_order) || '',
                    maximum_order: (props.customer && props.customer.restaurant.threshold) || '',
                    driver_fee: (props.customer && props.customer.restaurant.part_time_driver_fee) || '',
                    relationship_manager_phone_number: (props.customer && props.customer.relationship_manager_phone_number) || '+9665',
                    relation_manager_name_en: (props.customer && props.customer.relationship_manager_name) || '',
                    relation_manager_name_ar: (props.customer && props.customer.relationship_manager_name_ar) || '',
                    exclusive_ribbon: exclusive_ribbon,
                    car_type: (props.customer && props.customer.restaurant.delivery_car_type) || 'cooled',
                    cuisines_data: cuisines_data,
                    food_categories_data: (props.customer && props.foodCategories && shapeFoodCategores(props.customer.restaurant.food_categories, props.foodCategories)) || {},
                    branches: (props.customer && props.customer.restaurant.branches) || {},
                    is_active: props.customer && props.customer.is_active
                }}
                onSubmit={(submittedValues, actions) => {
                    const values = {...submittedValues};
                    const weekdays = WEEKDAYS.filter(weekday => submittedValues.weekdays[weekday.value]);
                    const opening_hours = weekdays.map(weekday => {
                        delete values[weekday.value];
                        return {
                            weekday: weekday.id,
                            from_hour: convertByTimeZone(submittedValues.from),
                            to_hour: convertByTimeZone(submittedValues.to),
                        };
                    });
                    const cuisines = Object.keys(values.cuisines_data).map(key => parseInt(key)).filter(item => values.cuisines_data[item + '_']);
                    const food_categories = Object.keys(values.food_categories_data).map(key => parseInt(key));
                    const branches = Object.keys(values.branches).map(key => {
                        return ({...values.branches[key]});
                    });
                    const data = {
                        restaurant: {
                            opening_hours,
                            cuisines,
                            food_categories,
                            branches,
                            name_en: submittedValues.customerName_ar,
                            name_ar: submittedValues.customerName_en,
                            phone_number: submittedValues.customerPhone,
                            description_en: submittedValues.description_en,
                            description_ar: submittedValues.description_ar,
                            image: submittedValues.image,
                            delivery_fee: submittedValues.agreed_delivery_fee,
                            user_share_delivery_fee: submittedValues.user_delivery_fee,
                            percentage_sales: parseInt(submittedValues.agreed_percent_sale),
                            part_time_driver_fee: submittedValues.driver_fee,
                            exclusive_ribbon: submittedValues.exclusive_ribbon === 'yes',
                            delivery_car_type: submittedValues.car_type,
                            minimum_order: submittedValues.minimum_order,
                            threshold: submittedValues.maximum_order,
                            delivery_time: submittedValues.delivery_time,
                            agreed_radius: submittedValues.agreed_radius
                        },
                        type: submittedValues.type,
                        username: submittedValues.username,
                        password: sha256(submittedValues.password),
                        relationship_manager_name_en: submittedValues.relation_manager_name_en,
                        relationship_manager_name_ar: submittedValues.relation_manager_name_ar,
                        relationship_manager_phone_number: submittedValues.relationship_manager_phone_number,
                        is_active: submittedValues.is_active
                    };
                    if (!props.customer) {
                        props.addCustomer(data).then(res => props.history.push('/customers'))
                    } else {
                        delete data.password;
                        if(data.password_edit) {
                            data.password = sha256(data.password_edit);
                            delete data.password_edit;
                        }
                        if(data.restaurant.image.indexOf('base64') === -1) {
                            delete data.restaurant.image;
                        }
                        props.editCustomer(props.customer.id, data).then(res => {
                            if (res.response && res.response.data && res.response.data.errors && res.response.data.errors[0].message === 'Customer have a active order') {
                                this.setState({ error: 'You can\'t deactivate this Customer as there is an active order.' });
                            } else{
                                this.setState({ error: null });
                                props.history.push('/customers');
                            }
                        });
                    }
                }}
                render={({ values, touched,setFieldValue, handleChange, handleBlur, errors, dirty, isSubmitting }) => {
                    return (
                        <Form>
                            <div className="box-body">
                                <div className="row justify-between">
                                    <div className="col-xs-6 pr-70">

                                        { this.props.customer && <TextFields type="text"
                                                                             disabled
                                                                             value={ this.props.customer.id }
                                                                             floatingLabelText="Customer Id" /> }

                                        <SelectMenu value={ values.type }
                                                    onChange={ setFieldValue }
                                                    name="type"
                                                    floatingLabelText="Customer Type"
                                                    menu={ CUSTOMER_TYPES } />

                                        <TextFields type="text"
                                                    error={ touched.username && errors.username }
                                                    value={ values.username }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    floatingLabelText="Customer Username"
                                                    name="username" />

                                        { this.props.customer && <TextFields type="password"
                                                                             error={ touched.password_edit && errors.password_edit }
                                                                             value={ values.password_edit }
                                                                             onChange={ handleChange }
                                                                             onBlur={ handleBlur }
                                                                             floatingLabelText="Customer Password"
                                                                             name="password_edit" /> }

                                        <TextFields type="password"
                                                    hide={this.props.customer}
                                                    error={ touched.password && errors.password }
                                                    value={  values.password }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    floatingLabelText="Customer Password"
                                                    name="password" />

                                        <InputTabs values={ values }
                                                   errors={ errors }
                                                   touched={ touched }
                                                   onChange={ setFieldValue }
                                                   onBlur={ handleBlur }
                                                   name="customerName"
                                                   floatingLabelText="Customer Name" />

                                        <TextFields value={ values.customerPhone.indexOf('+9665') === -1 ? (values.customerPhone.length < 5 ? '+9665': '+9665' + values.customerPhone) : values.customerPhone }
                                                    error={ touched.customerPhone && errors.customerPhone }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    type="text"
                                                    floatingLabelText="Customer Mobile Number"
                                                    name="customerPhone" />

                                        <div className="text-field with-tab">
                                            <label htmlFor="customer_desc" className="label">Customer Description</label>
                                            <InputTabs textarea
                                                       errors={ errors }
                                                       touched={ touched }
                                                       values={ values }
                                                       onChange={ setFieldValue }
                                                       onBlur={ handleBlur }
                                                       floatingLabelText="Customer Description"
                                                       name="description" />
                                        </div>

                                        <ImageUpload name="image"
                                                     error={ touched.image && errors.image }
                                                     value={ values.image }
                                                     onChange={ setFieldValue }
                                                     label="Customer HD Pic" />

                                        <div className="row">
                                            <div className="col-xs-12 mt-20 ">
                                                <p className="color-grey50 font-sm w-700">Customer Working Hours</p>
                                            </div>
                                            <div className="col-xs-6">
                                                <SelectMenu name="from"
                                                            value={ values.from }
                                                            error={ touched.from && errors.from }
                                                            onChange={ setFieldValue }
                                                            floatingLabelText="from"
                                                            menu={ HOURS }/>
                                            </div>
                                            <div className="col-xs-6">
                                                <SelectMenu name="to"
                                                            value={ values.to }
                                                            error={ touched.to && errors.to }
                                                            onChange={ setFieldValue }
                                                            floatingLabelText="to"
                                                            menu={ HOURS }/>
                                            </div>
                                        </div>
                                        <div className="mt-25">
                                            <p className="color-grey50 font-sm w-700 pb-10">Customer Working days</p>
                                            <ul className="flex wrap">

                                                {
                                                    DAYS.map(day => {
                                                        return (
                                                            <li className="mr-25 py-5" key={day}>
                                                                <label className="flex-center-y pointer w-600">
                                                                    <CheckboxElement name={ `weekdays.${day}` }
                                                                                     value={ values.weekdays && values.weekdays[day] }
                                                                                     onChange={ setFieldValue }
                                                                                     label={day} />
                                                                </label>
                                                            </li>
                                                        );
                                                    })
                                                }

                                            </ul>
                                        </div>

                                        <TextFields type="text"
                                                    value={ values.agreed_radius }
                                                    error={ touched.agreed_radius && errors.agreed_radius }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="agreed_radius"
                                                    floatingLabelText="Agreed Radius" />

                                        <TextFields type="text"
                                                    value={ values.agreed_delivery_fee }
                                                    error={ touched.agreed_delivery_fee && errors.agreed_delivery_fee }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="agreed_delivery_fee"
                                                    floatingLabelText="Agreed Delivery Fees" />

                                        <TextFields type="text"
                                                    value={ values.user_delivery_fee }
                                                    error={ touched.user_delivery_fee && errors.user_delivery_fee }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="user_delivery_fee"
                                                    floatingLabelText="User Share of Delivery Fees" />

                                        <TextFields type="text"
                                                    value={ values.delivery_time }
                                                    error={ touched.delivery_time && errors.delivery_time }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="delivery_time"
                                                    floatingLabelText="Delivery Time" />

                                        <TextFields type="text"
                                                    value={ values.agreed_percent_sale }
                                                    error={ touched.agreed_percent_sale && errors.agreed_percent_sale }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="agreed_percent_sale"
                                                    floatingLabelText="Agreed Percentage of Sales" />

                                        <TextFields type="text"
                                                    value={ values.minimum_order }
                                                    error={ touched.minimum_order && errors.minimum_order }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="minimum_order"
                                                    floatingLabelText="Minimum Order"/>

                                        <TextFields type="text"
                                                    value={ values.maximum_order }
                                                    error={ touched.maximum_order && errors.maximum_order }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="maximum_order"
                                                    floatingLabelText="Maximum Order" />

                                    </div>
                                    <div className="col-xs-6 pl-70">
                                        { this.props.customer ? <div className="text-right">
                                            <Link to={links.Menu(this.props.customer.id, this.props.customer.restaurant.id)}
                                                  className="flex-align-y font-sm w-800">
                                                <i className="fa fa-plus-circle mr-10 font-md"></i>
                                                Add Menu Heading
                                            </Link>
                                        </div> : null}

                                        <TextFields type="text"
                                                    value={ values.driver_fee }
                                                    error={ touched.driver_fee && errors.driver_fee }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="driver_fee"
                                                    floatingLabelText="Part time Driver Fees" />

                                        <TextFields type="text"
                                                    value={values.relationship_manager_phone_number.indexOf('+9665') === -1 ? (values.relationship_manager_phone_number.length < 5 ? '+9665': '+9665' + values.relationship_manager_phone_number)  : values.relationship_manager_phone_number }
                                                    error={ touched.relationship_manager_phone_number && errors.relationship_manager_phone_number }
                                                    onChange={ handleChange }
                                                    onBlur={ handleBlur }
                                                    name="relationship_manager_phone_number"
                                                    floatingLabelText="Relationship Manager Mobile Number" />

                                        <InputTabs errors={ errors }
                                                   touched={ touched }
                                                   values={ values }
                                                   onChange={ setFieldValue }
                                                   onBlur={ handleBlur }
                                                   name="relation_manager_name"
                                                   floatingLabelText="Relationship Manager Name" />

                                        <div className="mt-25">
                                            <p className="color-grey50 font-sm w-700 pb-10">Exclusive to Foodna Ribbon</p>
                                            <RadioGroup labelFirst="Yes"
                                                        valueFirst="yes"
                                                        labelSecond="No"
                                                        valueSecond="no"
                                                        onChange={ handleChange }
                                                        name="exclusive_ribbon"
                                                        error={ touched.exclusive_ribbon && errors.exclusive_ribbon }
                                                        value={ values.exclusive_ribbon } />
                                        </div>
                                        <SelectMenu value={ values.car_type }
                                                    error={ touched.car_type && errors.car_type }
                                                    onChange={ setFieldValue }
                                                    name="car_type"
                                                    menu={ CAR_TYPES }
                                                    floatingLabelText="Required Delivery Car Type" />

                                        <div className="mt-25">
                                            <p className="color-primary font-md w-700 pb-20">Customer Tag</p>
                                            <div>
                                                <p className="color-grey50 font-sm w-700 pb-10">Food Category</p>
                                                <ul className="flex wrap">

                                                    {
                                                        this.props.foodCategories ? this.props.foodCategories.map(foodCategory => {
                                                            const { id, name } = foodCategory;
                                                            return (
                                                                <li className="mr-25 py-5" key={id}>
                                                                    <label className="flex-center-y pointer w-600">
                                                                        <CheckboxElement label={ name }
                                                                                         name={`food_categories_data.${id}_`}
                                                                                         value={values.food_categories_data && values.food_categories_data[`${id}_`] }
                                                                                         onChange={ setFieldValue } />
                                                                    </label>
                                                                </li>
                                                            );
                                                        }) : null
                                                    }

                                                </ul>
                                            </div>
                                            <div className="mt-15">
                                                <p className="color-grey50 font-sm w-700 pb-10">Cuisine</p>
                                                <ul className="flex wrap">

                                                    {
                                                        this.props.cuisines ? this.props.cuisines.map(cuisine => {
                                                            const { id, name } = cuisine;
                                                            return (
                                                                <li className="mr-25 py-5" key={id}>
                                                                    <label className="flex-center-y pointer w-600">
                                                                        <CheckboxElement label={name}
                                                                                         name={`cuisines_data.${id}_`}
                                                                                         value={values.cuisines_data && values.cuisines_data[`${id}_`] }
                                                                                         onChange={ setFieldValue } />
                                                                    </label>
                                                                </li>
                                                            );
                                                        }) : null
                                                    }

                                                </ul>
                                            </div>

                                        </div>

                                        { this.props.customer ? this.state.locations[0].position && this.state.locations.map((location, index) => {
                                                return (
                                                    <BranchLocation key={ location.name }
                                                                    handleChange={handleChange}
                                                                    setFieldValue={ setFieldValue }
                                                                    name='branches'
                                                                    values={values}
                                                                    zones={ this.props.zones }
                                                                    isMapShown={ location.isMapShown }
                                                                    addLocation={ e => this.addLocation(e, index) }
                                                                    changeMapState={ e => this.changeMapState(e, location.name) }
                                                                    removeLocation={(e, index ) => this.removeLocation(e, index, setFieldValue, values) }
                                                                    location={ location }
                                                                    index={ index }
                                                                    locationsLength={ this.state.locations.length } />
                                                );
                                            }) : this.state.locations.map((location, index) => {
                                            return (
                                                <BranchLocation key={ location.name }
                                                                error={errors.branches}
                                                                handleChange={handleChange}
                                                                setFieldValue={ setFieldValue }
                                                                name='branches'
                                                                values={values}
                                                                zones={ this.props.zones }
                                                                isMapShown={ location.isMapShown }
                                                                addLocation={ e => this.addLocation(e, index) }
                                                                changeMapState={ e => this.changeMapState(e, location.name) }
                                                                removeLocation={(e, index ) => this.removeLocation(e, index, setFieldValue, values) }
                                                                location={ location }
                                                                index={ index }
                                                                locationsLength={ this.state.locations.length } />
                                            );
                                        })}

                                        <div className="mt-55">
                                            <p className="color-grey50 font-sm w-700 pb-10">Customer Status</p>
                                            <div className="flex-center-y">
                                                <span className="color-grey50 w-600 mr-15">Inactive</span>
                                                <SwitchToggle value={ values.is_active }
                                                              name="is_active"
                                                              onChange={ setFieldValue }/>
                                                <span className="color-primary w-600 ml-25">Active</span>
                                            </div>
                                            <span className='error-msg'>{ this.state.error }</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="box-meta">
                                <div className="text-right">
                                    <button type="submit" className="btn filled primary min-120">Save</button>
                                </div>
                            </div>
                        </Form>
                    );
                }}
            />
        );
    }
}


const mapStateToProps = state => {
    return {
        cuisines: state.customer.cuisines,
        zones: state.customer.zones,
        foodCategories: state.customer.foodCategories
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getFoodCategories: () => dispatch( getFoodCategories() ),
        getCuisines: () => dispatch( getCuisines() ),
        getZones: () => dispatch( getZones() ),
        addCustomer: data => dispatch( addCustomer(data) ),
        editCustomer: (id, data) => dispatch( editCustomer(id, data) )
    }
};


export default connect(mapStateToProps, mapDispatchToProps)( Customer );



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/CustomerForm.js